export default "__VITE_ASSET__XQiC5Uh7__"